/** Miniatura de produto do STAR com substituto quando não carrega (ex.: offline). */
import clsx from 'clsx';
import { Satellite } from 'lucide-react';
import { useEffect, useState } from 'react';
import { thumbnailUrl } from '../goes/star';

export function ProductThumbnail(props: { productId: string; className: string; lazy?: boolean; width: number; height: number }) {
  const { productId, className, lazy, width, height } = props;
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [productId]);

  if (broken) {
    return (
      <span className={clsx('flex items-center justify-center bg-ink-800 text-ink-500', className)} aria-hidden>
        <Satellite className="size-5" />
      </span>
    );
  }
  return (
    <img
      src={thumbnailUrl(productId)}
      alt=""
      width={width}
      height={height}
      loading={lazy ? 'lazy' : undefined}
      decoding="async"
      onError={() => setBroken(true)}
      className={clsx('bg-ink-800 object-cover', className)}
    />
  );
}
